class CollectionToolbar extends HTMLElement {
  constructor() {
    super();
    this.gridToggle = null;
    this.gridLabel = null;
    this.productGrid = null;
    this.controller = new AbortController();
  }

  connectedCallback() {
    this.gridToggle = this.querySelector('[data-grid-toggle]');
    this.gridLabel = this.querySelector('[data-grid-label]');
    this.gridIconUneven = this.querySelector('[data-grid-icon-uneven]');
    this.gridIconEven = this.querySelector('[data-grid-icon-even]');
    this.productGrid = document.querySelector('[data-product-grid]');

    if (this.gridToggle) {
      this.gridToggle.addEventListener('click', () => this.toggleGrid(), {
        signal: this.controller.signal,
      });
    }

    const saved = localStorage.getItem('collection-grid-type');
    if (saved === 'uneven') {
      this.applyGrid('uneven');
    }

    this.revealGrid();
  }

  revealGrid() {
    if (!this.productGrid) return;
    if (this.productGrid.hasAttribute('data-loading-previous')) return;
    const loading = document.querySelector('[data-grid-loading]');
    if (loading) loading.remove();
    requestAnimationFrame(() => {
      this.productGrid.classList.remove('opacity-0', 'grid-reveal-fallback');
    });
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  toggleGrid() {
    const current = this.productGrid?.dataset.gridType || 'even';
    this.applyGrid(current === 'even' ? 'uneven' : 'even');
  }

  applyGrid(type) {
    if (!this.productGrid) return;
    this.productGrid.dataset.gridType = type;
    localStorage.setItem('collection-grid-type', type);

    if (this.gridLabel) {
      this.gridLabel.textContent =
        type === 'even'
          ? this.getAttribute('data-label-change')
          : this.getAttribute('data-label-default');
    }

    if (this.gridIconUneven && this.gridIconEven) {
      this.gridIconUneven.classList.toggle('hidden', type === 'uneven');
      this.gridIconEven.classList.toggle('hidden', type === 'even');
    }
  }
}

if (!customElements.get('collection-toolbar')) {
  customElements.define('collection-toolbar', CollectionToolbar);
}
